'use strict';

var BaseDeviceController = require('components/devices/controllers/base_device_controller');

var GenericModbusController = BaseDeviceController.extend({});

module.exports = GenericModbusController;
